<!-- DESKTOP -->
<div *ngIf="showMe() && !isMobile" class="teiasoft-header">
    <div class="th-page-name">
        <span style="margin-left:1vw">{{title}}</span>
    </div>
    <div *ngIf="menuCfg" class="th-menu">
        <img *ngIf="pathLogo != ''" [src]="pathLogo" style="height: 5vh;">
        <i *ngFor="let item of menuCfg" [ngClass]="getIconClass(item)" (click)="onMenuClick(item)"
            [title]="'menu.' + item.tooltip | translate"></i>
    </div>
    <div class="th-user-name">
        <!-- <span *ngIf="globals.userLogged!" style="margin-right:1vw"><span class="th-span-blue">&#10033;</span> {{globals.userLogged!.username}}</span> -->
        <span style="margin-right:1vw"><span class="th-span-blue">&#10033;</span> {{userName}}</span>
        <span *ngIf="showSettings" style="margin-right:1vw" class="th-ico-settings"
            [ngClass]="{'th-ico-settings-active' : openSettings}" title="{{'commons.titleSettings' | translate}}"
            (click)="onOpenSettingsClick()">&#x2699;</span>
    </div>
</div>
<!-- SETTINGS CNT -->
<div *ngIf="openSettings" class="th-settings-cnt">
    <div class="th-settings-cnt-title">
        <span class="span-choose-theme">{{'commons.chooseTheme' | translate}}</span>
    </div>
    <div class="btn-theme-cnt">
        <div class="theme-btn" style="background-color: #0a6fc2;" (click)="setTheme($event, 'blue')"
            [ngClass]="{'border-active' : globals.theme == 'blue'}"></div>
        <div class="theme-btn" style="background-color: #265728;" (click)="setTheme($event, 'green')"
            [ngClass]="{'border-active' : globals.theme == 'green'}"></div>
        <div class="theme-btn" style="background-color: #535c69;" (click)="setTheme($event, 'silver')"
            [ngClass]="{'border-active' : globals.theme == 'silver'}"></div>
        <div class="theme-btn" style="background-color: #ac0930;" (click)="setTheme($event, 'red')"
            [ngClass]="{'border-active' : globals.theme == 'red'}"></div>

    </div>
    <div class="th-separator"></div>
    <div class="th-settings-cnt-title">
        <span class="span-choose-theme">{{'commons.chooseLanguage' | translate}}</span>
    </div>
    <div class="th-lang-cnt">
        <span class="th-span-language mr-5 mb-5" *ngFor="let item of languages"
            (click)="onSetLanguage($event, item.lang!)"
            [ngClass]="{'no-th-active' : globals.userLogged!.language != item.lang, 'th-active' : globals.userLogged!.language == item.lang}">
            <i *ngIf=" globals.userLogged!.language != item.lang" class="fal fa-circle gray"></i>
            <i *ngIf=" globals.userLogged!.language == item.lang" class="fas fa-check-circle green"></i>
            {{'languages.' + item.lang | translate}}</span>
    </div>
    <div class="th-separator"></div>
    <div class="th-settings-cnt-title">
        <span class="span-choose-theme">{{'commons.chooseDateFormat' | translate}}</span>
    </div>
    <div class="th-lang-cnt">
        <span class="th-span-language mr-5 mb-5" *ngFor="let df of dateFormats" (click)="onSetDateFormat($event, df!)"
            [ngClass]="{'no-th-active' : globals.userLogged!.dateFormat != df, 'th-active' : globals.userLogged!.dateFormat == df}">
            <i *ngIf=" globals.userLogged!.dateFormat != df" class="fal fa-circle gray"></i>
            <i *ngIf=" globals.userLogged!.dateFormat == df" class="fas fa-check-circle green"></i>
            {{df}}</span>
    </div>
</div>



<!-- MOBILE -->
<div *ngIf="showMe() && isMobile" class="teiasoft-header-mobile">
    <div class="th-col-sx-mobile">
        <img *ngIf="pathLogo != ''" [src]="pathLogo" style="height: 52px;">
    </div>
    <div class="th-col-dx-mobile">
        <span *ngIf="!isMenuOpen" class="th-ico-mobile" (click)="onClickMenu()">&#9776;</span>
        <span *ngIf="isMenuOpen" class="th-ico-mobile" (click)="onClickMenu()">&#9747;</span>
    </div>
</div>

<div id="cntMenuMobile" class="th-menu-mobile">
    <div *ngFor="let item of menuCfg; trackBy:identify" class="row-menu-mobile">
        <span class="th-span-mobile" (click)="onMenuClick(item)">{{item.label}}</span>
    </div>
    <!-- <div class="row-menu-mobile">
        <span class="th-span-mobile" (click)="onMenuClickMobile('home')">Home</span>
    </div>
    <div class="row-menu-mobile">
        <span class="th-span-mobile" (click)="onMenuClickMobile('guidelinesmobile')">Guidelines</span>
    </div>
    <div class="row-menu-mobile">
        <span class="th-span-mobile" (click)="onMenuClickMobile('bucketmobile')">Bucket</span>
    </div>
    <div class="row-menu-mobile">
        <span class="th-span-mobile" (click)="onMenuClickMobile('logout')">Logout</span>
    </div> -->
    <div class="tb-divider"></div>
    <span class="th-span-version">{{'Version ' + globals.appVersion}}</span>
</div>